import * as constant from '../constant.js';
export default function (state = {redirectUrl:"/landingPage"}, action) {
	let newState = {};
    switch (action.type) {
        case constant.SET_REDIRECT_URL:  
            newState.redirectUrl= action.payload;
            return newState;
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/reducer-redirect-url.js